import React from 'react';
import "./countrySelection.scss"

import jamaicaIcon from "../../assets/jamaica_icon.svg"
import grenadaIcon from "../../assets/grenada_icon.svg"
import londonIcon from "../../assets/london_icon.svg"
import trinidadIcon from "../../assets/trinidad_icon.svg"
import unitedStatesIcon from "../../assets/us_icon.svg"
import caymanIcon from "../../assets/cayman_icon.svg"
import Select from "react-select";
import {useCountryContextContext} from "../../hooks/CountryContext";

const options = [
    {value: 'jamaica', label: <img src={jamaicaIcon} height="30px" width="30px" alt=""/>},
    {value: 'cayman', label: <img src={caymanIcon} height="30px" width="30px" alt=""/>},
    {
        value: 'unitedStates',
        label: <img src={unitedStatesIcon} height="30px" width="30px" alt=""/>
    },
    {value: 'trinidad', label: <img src={trinidadIcon} height="30px" width="30px" alt=""/>},
    // {value: 'grenada', label: <img src={grenadaIcon} height="30px" width="30px" alt=""/>},
]

const countryTheme = (theme) => {
    return {
        ...theme,
        colors: {
            ...theme.colors,
            primary25: '#7d77dc',
            primary: '#7d77dc',
        }
    }
}
const CountrySelection = () => {
    const selectedCountry = useCountryContextContext();
    return (
        <div className="country_select">
            <div>Please Select country service location:</div>

            <div>

            <Select
                onChange={selectedCountry.setCountry}
                theme={countryTheme}
                className="footer__wrapper__top__columns__select"
                placeholder="Select Country"
                options={options}
                autoFocus
                defaultValue={selectedCountry.country ?? {
                    value: 'jamaica',
                    label: <img src={jamaicaIcon} height="30px" width="30px"
                                alt=""/>
                }}
            />
            </div>
        </div>
    );
}

export default CountrySelection;
